import React, { useState, useEffect, useRef } from "react";
import "./Checkbox.scss";

const showInformativeText = (checked, updateInformativeState, hideInformative = false, link) => {
  const informativeMessage = document.querySelector(".informative-message");

  if (!checked) {
    let inputs = document.querySelectorAll(".process-filter-input");
    let empty = [].filter.call(inputs, function (el) {
      return !el.checked;
    });
    let inputsChecked = [];
    inputs.forEach((item) => {
      if (item.checked) inputsChecked.push(item);
    });

    let activeLinkFilters = inputsChecked.filter(item => {
      let link = document.querySelector(`.process-filter-link-${item.value}`);
      if (link && link.text) {
        return item;
      }
    });

    if (activeLinkFilters.length <= 0) {
      informativeMessage.classList.remove("show");
      return;
    }

    if (inputs.length === empty.length) {
      informativeMessage.classList.remove("show");
    }

    if (hideInformative.state) {
      informativeMessage.classList.remove("show");
    }
  } else {
    if (link && link.text) {
      informativeMessage.classList.add("show");
    }
    updateInformativeState(false, false);
  }

  if (checked === "hide") {
    informativeMessage.classList.remove("show");
  }
};

const showLink = (event, addActiveFilter, updateInformativeState, hide = false) => {
  let link = document.querySelector(`.process-filter-link-${event.value}`);
  if (hide) {
    link.classList.remove("show");
  } else {
    link.classList.toggle("show");
    showInformativeText(event.checked, updateInformativeState, false, link);
    addActiveFilter(event.value)
  }
};

export const Checkbox = ({ props, addActiveFilter, activeFilters, updateInformativeState, hideInformative }) => {
  let wrapperClass = "checkbox-wrapper";
  const [isChecked, setIsChecked] = useState(false);
  const checkBoxRef = useRef(null);

  useEffect(()=>{
    if (activeFilters.indexOf(props.id.toString()) === -1) {
      setIsChecked(false);
    }
  }, [activeFilters, props.id]);

  useEffect(() => {
    if (hideInformative.all) {
      showLink(checkBoxRef.current, false, false, true);
      showInformativeText("hide", updateInformativeState);
    }
  }, [hideInformative, updateInformativeState]);

  return (
    <div className={wrapperClass}>
      <input
        aria-labelledby={`label-${props.id}`}
        id={`input-${props.id}`}
        className="process-filter-input"
        type="checkbox"
        name={props.id}
        value={props.id}
        checked={isChecked}
        ref={checkBoxRef}
        onChange={(event) => {
          showLink(event.target, addActiveFilter, updateInformativeState);
          setIsChecked(!isChecked);
        }}
      ></input>
      <label
        id={`label-${props.id}`}
        className="label process-filter-label"
        htmlFor={`input-${props.id}`}
        dangerouslySetInnerHTML={{
          __html: props.label,
        }}
      ></label>
    </div>
  );
};
